// /Users/pramod/Desktop/school-erp/frontend/src/Tenant/TenantWebsite/utils/useBrandColors.js

import { useContext } from 'react';
import { BrandingContext } from '../index';

export const useBrandColors = () => {
  const context = useContext(BrandingContext);
  
  const defaultColors = {
    primary: '#1a1a2e',
    secondary: '#c9a84c',
    fontFamily: 'Inter',
    primaryLight: '#1a1a2e20',
    secondaryLight: '#c9a84c20',
    primaryDark: '#1a1a2e80',
    secondaryDark: '#c9a84c80',
    fontHeading: 'Inter',
    fontBody: 'Inter',
    fontMono: 'monospace',
  };
  
  if (!context || Object.keys(context).length === 0) {
    return defaultColors;
  }
  
  const colors = { ...defaultColors, ...context };
  
  if (colors.primary && !context?.primaryLight) {
    colors.primaryLight = `${colors.primary}20`;
    colors.primaryDark = `${colors.primary}80`;
  }
  
  if (colors.secondary && !context?.secondaryLight) {
    colors.secondaryLight = `${colors.secondary}20`;
    colors.secondaryDark = `${colors.secondary}80`;
  }
  
  // Use context fontFamily if provided
  if (context.fontFamily) {
    colors.fontFamily = context.fontFamily;
  }
  
  // Set heading and body fonts
  if (!colors.fontHeading || colors.fontHeading === 'Inter') {
    colors.fontHeading = colors.fontFamily || 'Inter';
  }
  if (!colors.fontBody || colors.fontBody === 'Inter') {
    colors.fontBody = colors.fontFamily || 'Inter';
  }
  
  return colors;
};

export default useBrandColors;